import raw from "../../rawClients/rawCapiClient";
import capiRoutes from "../../capiRoutes";
export default {
  getOneInProject(projectUid, sheetUid) {
    return raw.get(capiRoutes.sheets.oneInProject(projectUid, sheetUid));
  },
  getAllInProject(projectUid, params) {
    if (params.extraFields) {
      params.extra_fields = params.extraFields.join(",");
      delete params.extraFields;
    }
    return raw.getAll(capiRoutes.sheets.allInProject(projectUid), params);
  },
  createSheetUpload(projectUid, params) {
    return raw.post(capiRoutes.sheets.uploads(projectUid), params);
  },
  getSheetUploadFile(
    projectUid,
    versionUploadUid,
    fileUploadRequestUid,
    params
  ) {
    return raw.post(
      capiRoutes.sheets.uploadFileToVersion(
        projectUid,
        versionUploadUid,
        fileUploadRequestUid
      ),
      params
    );
  },
  startSheetProcessing(projectUid, versionUploadUid, body = undefined) {
    return raw.post(
      capiRoutes.sheets.completeVersionUpload(projectUid, versionUploadUid),
      body
    );
  },
};
